import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  Typography
} from '@mui/material';
import { Search as  SearchIcon} from '@mui/icons-material';

export const ProfileListToolbar = ({teacher, openModal}) => (
  <Box>
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        m: -1
      }}
    >
      <Typography
        sx={{ m: 1 }}
        variant="h5"
      >
        Profesor: {teacher.fullName}
      </Typography>
      <Box sx={{ m: 1 }}>
        <Button
          color="primary"
          variant="contained"
          onClick={openModal}
        >
          Agregar Curso
        </Button>
      </Box>
    </Box>
    <Box sx={{ mt: 3 }}>
      {/* <Card>
        <CardContent>
          <Box>
            <TextField
              type='search'
              fullWidth
              size='small'
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon
                      fontSize="small"
                      color="action"
                    >
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                )
              }}
              placeholder="Buscar producto"
              variant="outlined"
            />
          </Box>
        </CardContent>
      </Card> */}
    </Box>
  </Box>
);
